const baseUrl = process.env.REACT_APP_BASE_URL || 'https://mv-profile-959685280830.asia-south1.run.app';

export const EnvironmentManager = {
  baseUrl,
  endpoints: {
    
    saveUserDetails: "/mv-profile/profile-user-details/save-user-details",
    updateUserDetails: "/mv-profile/profile-user-details/update-user-details",
    getUserDetails: "/mv-profile/profile-user-details/get-user-details",
    deleteUserDetails: "/mv-profile/profile-user-details/delete-user-details",

    saveResumeDocument: "/mv-profile/profile-resume-document/save-profile-resume-document",
    updateResumeDocument: "/mv-profile/profile-resume-document/update-profile-resume-document",
    getResumeDocument: "/mv-profile/profile-resume-document/get-profile-resume-document",
    deleteResumeDocument: "/mv-profile/profile-resume-document/delete-profile-resume-document",

    saveUserAddress: "/mv-profile/profile-user-address/save-user-address",
    getUserAddress: "/mv-profile/profile-user-address/get-user-address",
    updateUserAddress: "/mv-profile/profile-user-address/update-user-address", 
    deleteUserAddress: "/mv-profile/profile-user-address/delete-user-address",

    uploadCourseDetails: "/mv-profile/audio-courses/upload-course-details",
    updateCourseDetails: "/mv-profile/audio-courses/update-course-details",
    getCourseDetailsByUser: "/mv-profile/audio-courses/get-course-details/by-user",
    deleteCourseDetails: "/mv-profile/audio-courses/delete-course-details",
    archiveCourse: "/mv-profile/audio-courses/archive-course",
    unarchiveCourse: "/mv-profile/audio-courses/unarchive-course",

    textToSpeech: "/mv-profile/convert/text-to-speech",
    streamAudio: "/mv-profile/convert/stream-audio",
    getAvailableVoices: "/mv-profile/convert/available-voices",

    // Video Courses API
    uploadVideoCourseDetails: "/mv-profile/video-courses/upload-course-details",
    getVideoCourseDetailsByUser: "/mv-profile/video-courses/get-course-details/by-user",
    updateVideoCourseDetails: "/mv-profile/video-courses/update-course-details", 
    deleteVideoCourseDetails: "/mv-profile/video-courses/delete-course-details", 
    archiveVideoCourse: "/mv-profile/video-courses/archive-course", 
    unarchiveVideoCourse: "/mv-profile/video-courses/unarchive-course",
   
    updateVideoCourseExcel: "/mv-profile/video-courses/update-course-excel",
    updateVideoCourseVideos: "/mv-profile/video-courses/update-course-videos",
    getCourseWithExcel: "/mv-profile/video-courses/course-with-excel",

    // Random Courses API
    getRandomDetailedCourses: "/mv-profile/audio-courses/random-detailed",

     // File download endpoint
    downloadFile: "/mv-profile/files/download",

    // Search API endpoint
    searchCourses: "/mv-profile/audio-courses/search",

  },
  config: {
    requestTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 60000,
    maxUploadSize: parseInt(process.env.REACT_APP_MAX_UPLOAD_SIZE) || 10 * 1024 * 1024,
    maxRetries: parseInt(process.env.REACT_APP_MAX_RETRIES) || 3,
    retryDelay: parseInt(process.env.REACT_APP_RETRY_DELAY) || 1000,
  },
};

export const buildUrl = (endpoint, id = null) => {
  let url = `${EnvironmentManager.baseUrl}${endpoint}`;
  if (id) {
    url += `/${id}`;
  }
  return url;
};

export default EnvironmentManager;